<template>
  <default-layout>
     <v-layout wrap>

         <v-flex xs12 class="pt-5">
            <v-card class="elevation-12">
              <v-toolbar dark color="blue darken-1">
                <v-toolbar-title>Edit Password</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-container grid-list-md mx-1>
                    <v-layout wrap>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-validate="'required'"
                          :error-messages="errors.collect('password')"
                          data-vv-name="password"
                          v-model="password"
                          label="New Password"
                          type="password"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-validate="'required'"
                          :error-messages="errors.collect('confirmPass')"
                          data-vv-name="confirmPass"
                          v-model="confirmPass"
                          label="Confirm Password"
                          type="password"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-btn color="blue darken-1" @click="save" :loading="loading" dark>Submit</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
         </v-flex>
     </v-layout>
     <app-snackbar ref="mySnackbar"></app-snackbar>
  </default-layout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: 'EditPasswordPage',
  computed: {
    ...mapGetters(["user"])
  },
  data () {
    return {
      password: null,
      confirmPass: null,
      loading: false,
      success_msg: null
    };
  },
  methods: {
    save() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          if (this.password !== this.confirmPass) {
            this.$refs.mySnackbar.show("Passwords Don't match !", "red");
          } else {
            const data = {
              password: this.password,
              phone: this.user.phone
            };

            const self = this;
            self.loading = true;
            const res = this.$store
              .dispatch("post", { url: "/user/password/changepassword", data })
              .then(res => {
                self.loading = false;
                if (res.state == false) {
                  this.$refs.mySnackbar.show(res.msg, "red");
                } else {
                  this.$refs.mySnackbar.show("Password updated successfully.", "green");
                }
              })
              .finally(() => {
                // stuffs happens here
              });
          }
        }
      });
      //end of validation
    }
  }
}
</script>
